import React from 'react'
import { Icon } from '../../atoms/Icon'
import { InfoTooltip } from '../../InfoTooltip'
import type { InfoCardProps } from './InfoCard.types'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
  MetricHighlight,
} from './InfoCard.styles'

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  icon,
  iconColor,
  metrics,
  badge,
  className,
}) => {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>
          {icon && <Icon name={icon} size="small" color={iconColor} />}
          {title}
        </CardTitle>
        {badge}
      </CardHeader>
      <MetricGrid>
        {metrics.map((metric, index) => (
          <MetricRow key={index}>
            <MetricLabel>
              {metric.label}
              {metric.tooltip && <InfoTooltip>{metric.tooltip}</InfoTooltip>}
            </MetricLabel>
            <MetricValue>
              {metric.highlightType ? (
                <MetricHighlight $type={metric.highlightType}>
                  {metric.value}
                </MetricHighlight>
              ) : (
                metric.value
              )}
            </MetricValue>
          </MetricRow>
        ))}
      </MetricGrid>
    </Card>
  )
}

InfoCard.displayName = 'InfoCard'
